<template>
  <!-- 信号值图形 -->
  <div class="signal">
    <div v-for="index in 5" :key="index" :class="getBarClass(index)"></div>
  </div>
</template>
<script>
export default {
  props: {
    // 信号强度
    strength: {
      default: 0
    }
  },
  data() {
    return {
      limit: {
        1: 15,
        2: 35,
        3: 55,
        4: 75,
        5: 95,
      }
    }
  },
  methods: {
    // 计算柱状块样式类
    getBarClass(index) {
      let classList = [`bar-${index}`]
      if (this.strength >= this.limit[index]) {
        classList.push('active')
      }
      return classList
    }
  },
}
</script>
<style lang="less" scoped>
@import url("../assets/css/mixin.less");
.signal {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .bar {
    width: 4px;
    border-radius: 7.5px;
    // background: @borderColor;
    background: #e8ecee;
    margin: 0 1px;
    &.active {
      // background: @themeColor;
      background: rgb(73, 146, 255);
    }
  }
  --bar-height: 5px; 
  .bar-1 {
    .bar;
    height: var(--bar-height);
  }
  .bar-2 {
    .bar;
    height: calc(var(--bar-height) + 5px);
  }
  .bar-3 {
    .bar;
    height: calc(var(--bar-height) + 10px);
  }
  .bar-4 {
    .bar;
    height: calc(var(--bar-height) + 15px);
  }
  .bar-5 {
    .bar;
    height: calc(5 * var(--bar-height) + 2px);
  }
}
</style>